
<template>
  <base-modal
    :title="title"
    :width="width"
    :height="height"
    :visible="visible"
    @cancel="open(false)"
  >
    <div slot="modalBody">
      <a-form :form="form">
        <a-form-item>
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-form layout="inline">
                <a-row :gutter="48">
                  <a-col :md="8" :sm="24">
                    <a-form-item label="名称">
                      <a-input placeholder="请输入名称" v-model="searchForm.userName" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <a-form-item label="编号">
                      <a-input placeholder="请输入编号" v-model="searchForm.userNumber" />
                    </a-form-item>
                  </a-col>
                  <a-col :md="8" :sm="24">
                    <span class="table-page-search-submitButtons">
                      <a-button type="primary" @click="search">查询</a-button>
                      <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </a-form>
          </div>
          <div>
            <a-table
              :rowSelection="rowSelection"
              :columns="table.columns"
              :dataSource="table.data"
              :loading="table.loading"
              :pagination="pagination"
              @change="handleTableChange"
              size="small"
              :scroll="{ y: 185 }"
            ></a-table>
          </div>
          <div style="border-top:1px solid #eee;">
            <span style="margin:0 8px 0 8px">已选人员:</span>
            <span v-if="hasSelected">
              <template v-for=" (item,index) in mList">
                <a-tag :key="item.userId" closable @close="log(index)">{{ item.userName }}</a-tag>
              </template>
            </span>
          </div>
        </a-form-item>
        <a-form-item style="text-align:center">
          <a-button type="primary" @click="handleSubmit" style="margin-right:10px;" :loading="iconLoading">保存</a-button>
          <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
        </a-form-item>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'

import { getUserChooseList, insertGroup } from '@/api/group'

const columns = [
  {
    title: '名称',
    dataIndex: 'userName',
    width: 150
  },
  {
    title: '编号',
    dataIndex: 'userNumber',
    width: 150
  },
  {
    title: '角色',
    dataIndex: 'roleNameList'
  }
]
const data = []
for (let i = 0; i < 46; i++) {
  data.push({
    key: i,
    userId: i,
    userName: `Edward King ${i}`,
    userNumber: 32,
    roleNameList: `London, Park Lane no. ${i}`
  })
}

export default {
  name: 'EditGroup',
  mounted () {},
  components: {
    baseModal
  },
  data () {
    return {
      title: '选择人员',
      width: 800,
      height: 900,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'group' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 表格搜索框
      searchForm: {
        userName: '',
        userNumber: ''
      },
      // 所有搜索条件 用于表格接口传参
      searchModel: {},
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: data,
        columns: [{
          title: '名称',
          dataIndex: 'userName',
          width: 150
        },
        {
          title: '编号',
          dataIndex: 'userNumber',
          width: 150
        },
        {
          title: '角色',
          dataIndex: 'roleNames'
        }],
        loading: false
      },
      data: [],
      columns,
      selectedUserIds: [], // 选择的用户id
      loading: false,
      iconLoading: false,
      mList: [
        {
          userName: '',
          key: ''
        }
      ]
    }
  },
  methods: {
    // 打开or关闭
    open (flag) {
      this.formClear()
      this.title = `【${this.groupName}】添加人员`
      this.searchForm.groupId = this.groupId
      this.searchModel = {
        ...this.searchForm,
        ...this.pagination
      }
      this.visible = flag
      this.inUserData()
    },
    inUserData () {
      this.searchModel.userName = this.searchModel.userName.trim()
      this.searchModel.userNumber = this.searchModel.userNumber.trim()
      getUserChooseList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list.map(item => {
            return {
              ...item,
              key: item.userId
            }
          })

          this.pagination.total = res.data.total
        }
      })
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchForm,
        ...this.pagination
      }
      this.inUserData()
    },
    // 点击查询按钮
    search () {
      this.searchModel = { ...this.searchForm, ...this.pagination }
      this.inUserData()
    },
    // 点击复位按钮
    clearSearch () {
      this.searchForm.userName = ''
      this.searchForm.userNumber = ''
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.searchForm, ...this.pagination }
      this.inUserData()
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          this.iconLoading = true
          if (this.selectedUserIds.length !== 0) {
            const params = {
              groupId: this.groupId,
              userIds: this.selectedUserIds.toString()
            }
            insertGroup(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
                this.iconLoading = false
              } else {
                this.$message.error(res.info.message)
                this.iconLoading = false
              }
            })
          } else {
            this.$message.error('请至少选择一行数据进行保存！')
            this.iconLoading = false
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.clearSearch()
      this.selectedUserIds = []
      this.mList = []
    },
    cancel () {
      this.open(false)
      this.formClear()
    },
    // 关闭已选人员
    log (index) {
      this.mList.splice(index, 1)
      const userIds = []

      this.mList.map(item => {
        userIds.push(item.userId)
        return item
      })
      this.selectedUserIds = userIds
    }
  },
  computed: {
    groupId () {
      return this.$store.state.group.groupId
    },
    groupName () {
      return this.$store.state.group.groupName
    },
    hasSelected () {
      return this.selectedUserIds.length > 0
    },
    rowSelection () {
      return {
        selectedRowKeys: this.selectedUserIds,
        onChange: (selectedUserIds, selectedRows) => {
          for (const i in selectedUserIds) {
            if (this.selectedUserIds.indexOf(selectedUserIds[i]) === -1) {
              this.selectedUserIds.push(selectedUserIds[i])
            }
          }
        },
        onSelect: (record, selected, selectedRows) => {
          const mListUserIds = this.mList.map(item => {
            return item.userId
          })
          const userId = record.userId
          if (selected === true) {
            if (this.selectedUserIds.indexOf(userId) === -1) {
              this.selectedUserIds.push(userId)
            }
            if (mListUserIds.indexOf(userId) === -1) {
              this.mList.push({ userName: record.userName, userId: record.userId })
            }
          } else {
            console.log(userId)
            const index = this.selectedUserIds.indexOf(userId)
            index != -1 && this.selectedUserIds.splice(index, 1)
            // 获取mList
            this.mList = this.mList.filter(item => {
              return this.selectedUserIds.indexOf(item.userId) > -1 ? item : 0
            })
          }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          const mListUserIds = this.mList.map(item => {
            return item.userId
          })
          if (selected === true) {
            for (const i in changeRows) {
              if (this.selectedUserIds.indexOf(changeRows[i].userId) === -1) {
                this.selectedUserIds.push(changeRows[i].userId)
              }
              if (mListUserIds.indexOf(changeRows[i].userId) === -1) {
                this.mList.push({ userName: changeRows[i].userName, userId: changeRows[i].userId })
              }
            }
          } else {
            for (const j in changeRows) {
              const userId = changeRows[j].userId
              const index = this.selectedUserIds.indexOf(userId)
              index !== -1 && this.selectedUserIds.splice(index, 1)
              // 获取mList
              this.mList = this.mList.filter(item => {
                return this.selectedUserIds.indexOf(item.userId) > -1 ? item : 0
              })
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
